import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { useText } from 'common/hooks';
import {
  primaryLanguage,
  secondaryLanguages,
  unfinishedLanguages,
  languageNames,
} from 'languages/config';

import PageContainer from '../common/PageContainer';
import { RadioWrapper, Radio } from './elements';
import { PageWrapper, Title } from '../elements';

const languages = [
  primaryLanguage,
  ...secondaryLanguages.filter(l => !unfinishedLanguages.includes(l)),
];

const deps = {
  currentLanguage: state.appContainer.language.locale,
  languageSelected: sequences`appContainer.languageSelected`,
};

export function Language({
  currentLanguage,
  languageSelected,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <PageContainer tab={'language'}>
      <PageWrapper>
        <Title as={'h2'}>{t('account.settings.language')}</Title>
        <RadioWrapper>
          {languages.map(language => (
            <Radio
              key={`language-selector-${language}`}
              onClick={() => languageSelected({ language })}
              label={languageNames[language]}
              checked={currentLanguage === language}
            />
          ))}
        </RadioWrapper>
      </PageWrapper>
    </PageContainer>
  );
}

export default connect(deps, Language);
